/** What a joined student's browser keeps: the respondent token per session, in sessionStorage
 * so closing the tab ends the sitting (a reload keeps it). */
import { storageKey } from "../product";

export type Joined = {
  session_id: string;
  respondent_id: string;
  token: string;
  join_mode: string;
  /** The guest principal (STORY-016): kept for history claim and promotion. */
  subject?: string | null;
  guest_token?: string | null;
};

const key = (sid: string) => storageKey(`joined.${sid}`);
const LAST = storageKey("joined.last");

export function rememberJoin(j: Joined): void {
  try {
    sessionStorage.setItem(key(j.session_id), JSON.stringify(j));
    sessionStorage.setItem(LAST, j.session_id);
  } catch {
    /* ignore */
  }
}

/** The sitting this browser last joined, for the resume card on the student landing. Same
 * lifetime as the per-session record: closing the tab or killing the app ends the sitting. */
export function lastJoin(): Joined | null {
  try {
    const sid = sessionStorage.getItem(LAST);
    return sid ? recallJoin(sid) : null;
  } catch {
    return null;
  }
}

export function recallJoin(sid: string): Joined | null {
  try {
    const raw = sessionStorage.getItem(key(sid));
    return raw ? (JSON.parse(raw) as Joined) : null;
  } catch {
    return null;
  }
}
